import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Alert, CircularProgress, InputAdornment, IconButton } from '@mui/material';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { resetPassword } from '../services/api';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPass, setShowPass] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Las contraseñas no coinciden'); return; }
    if (password.length < 8) { setError('La contraseña debe tener al menos 8 caracteres'); return; }
    setLoading(true);
    try {
      await resetPassword(token, password);
      navigate('/?reset=1');
    } catch (err) {
      setError(err.userMessage || 'El link es inválido o ya expiró. Solicitá uno nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
        <Paper sx={{ maxWidth: 400, width: '100%', p: 4 }}>
          <Alert severity="error" sx={{ mb: 2 }}>Link inválido. El link de reset debe incluir un token.</Alert>
          <Link to="/forgot-password" style={{ fontSize: 13, color: '#1565c0' }}>Solicitar un nuevo link</Link>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: 'background.default', p: 2 }}>
      <Paper sx={{ maxWidth: 400, width: '100%', p: 4, borderRadius: 2 }}>
        <Typography variant="h5" fontWeight={700} mb={0.5}>Nueva contraseña</Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Ingresá tu nueva contraseña. Debe tener al menos 8 caracteres.
        </Typography>

        <form onSubmit={handleSubmit}>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          <TextField
            fullWidth label="Nueva contraseña" required size="small"
            type={showPass ? 'text' : 'password'}
            value={password} onChange={e => setPassword(e.target.value)}
            sx={{ mb: 2 }}
            error={!!error && (error.includes('al menos 8') || error.includes('coinciden'))}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setShowPass(p => !p)}>
                    {showPass ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />

          <TextField
            fullWidth label="Confirmar contraseña" required size="small"
            type={showPass ? 'text' : 'password'}
            value={confirm} onChange={e => setConfirm(e.target.value)}
            sx={{ mb: 2 }}
            error={!!error && error.includes('coinciden')}
          />

          <Button
            fullWidth type="submit" variant="contained"
            disabled={loading || !password || !confirm}
            sx={{ mb: 2 }}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : 'Guardar contraseña'}
          </Button>
        </form>

        <Box sx={{ textAlign: 'center' }}>
          <Link to="/" style={{ fontSize: 13, color: '#1565c0' }}>← Volver al login</Link>
        </Box>
      </Paper>
    </Box>
  );
};

export default ResetPassword;
